module.exports = __webpack_public_path__ + "img/rnd3.fd40a267.jpg";